import { transparentize } from 'polished';
import { colors } from '@keen.io/colors';
export var sliderSettings = {
    vertical: {
        buttonVariant: 'horizontal',
        previousButton: {
            position: 'top',
            icon: 'caret-up',
            gradient: 'to bottom',
            shadow: "0px 5px 5px " + transparentize(0.1, colors.white['500']),
        },
        nextButton: {
            position: 'bottom',
            icon: 'caret-down',
            gradient: 'to top',
            shadow: "0px -5px 5px " + transparentize(0.1, colors.white['500']),
        },
    },
    horizontal: {
        buttonVariant: 'vertical',
        previousButton: {
            position: 'left',
            icon: 'caret-left',
            gradient: 'to right',
            shadow: "5px 0px 5px " + transparentize(0.1, colors.white['500']),
        },
        nextButton: {
            position: 'right',
            icon: 'caret-right',
            gradient: 'to left',
            shadow: "-5px 0px 5px " + transparentize(0.1, colors.white['500']),
        },
    },
};
